import React, { useState } from 'react';
import { TelegramLogo, X } from '@phosphor-icons/react';

export const TelegramPromoCard = () => {
  const [dismissed, setDismissed] = useState(() => localStorage.getItem('tg_promo_dismissed') === '1');
  let linked = false;
  try {
    linked = !!JSON.parse(localStorage.getItem('user') || '{}').telegram_user_id;
  } catch (e) { /* ignore */ }
  if (dismissed || linked) return null;
  return (
    <div className="relative bg-[#1C93E3] border-2 border-black rounded-2xl p-4 mb-4 flex flex-wrap items-center gap-3 shadow-[4px_4px_0px_#000]" data-testid="telegram-promo-card">
      <button
        onClick={() => { localStorage.setItem('tg_promo_dismissed', '1'); setDismissed(true); }}
        className="absolute top-2 right-2 text-white/70 hover:text-white"
        data-testid="telegram-promo-dismiss"
        aria-label="Dismiss"
      >
        <X size={16} weight="bold" />
      </button>
      <span className="w-11 h-11 flex items-center justify-center bg-white border-2 border-black rounded-xl shrink-0">
        <TelegramLogo size={24} weight="fill" className="text-[#1C93E3]" />
      </span>
      <div className="flex-1 min-w-[200px]">
        <p className="font-black uppercase text-sm text-white">New: ConstructHelp on Telegram 📱</p>
        <p className="text-xs text-white/85 mt-0.5">Get instant alerts for jobs, offers and messages — open our bot and tap Start.</p>
      </div>
      <a
        href="https://t.me/Constructhelp123bot"
        target="_blank"
        rel="noreferrer"
        className="bg-white text-[#1C93E3] font-black uppercase text-xs px-4 py-2.5 border-2 border-black rounded-lg shrink-0"
        data-testid="telegram-promo-open-btn"
      >
        Open Telegram
      </a>
    </div>
  );
};
